var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQpr16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0971 14.5936C15.6869 13.1317 16.6854 11.0387 16.6854 8.714C16.6854 4.31225 13.1065 0.733337 8.70478 0.733337C4.30304 0.733337 0.724121 4.31225 0.724121 8.714C0.724121 13.1157 4.30304 16.6947 8.70478 16.6947H17.1488C16.5656 15.752 15.3913 15.073 14.0971 14.5936ZM3.95154 8.714C3.95154 6.09372 6.08451 3.96075 8.70478 3.96075C11.3251 3.96075 13.458 6.09372 13.458 8.714C13.458 11.3343 11.3251 13.4673 8.70478 13.4673C6.08451 13.4673 3.95154 11.3343 3.95154 8.714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQpr16);
export default __webpack_public_path__ + "static/media/QPR16.641fbef41e973b4a22dff6dd5e790869.svg";
export { ForwardRef as ReactComponent };